var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesign3DIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 350,
    fill: "#2F24E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119 198L174.5 288L191.5 260.5L148 190.5V69H119V198Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M230 197L200.5 245.5L187.5 226.5L200.5 193.5V69H230V197Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M265 292.5H205L214.5 276H265V292.5Z",
    fill: "white",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M281 264.5H221L230.5 248H281V264.5Z",
    fill: "white",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M297 237.5H237L246.5 221H297V237.5Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign3DIcon);
export default __webpack_public_path__ + "static/media/Design3D-icon.32cf7482deaf5a44918dd82a2b135c6d.svg";
export { ForwardRef as ReactComponent };